package one.healthium.update_food_preferences.ui

sealed interface UpdateFoodPreferencesEvent {
    data object OnFoodPreferencesSaved : UpdateFoodPreferencesEvent
}